import * as caching from "caching"
import * as timex from "timex"
import * as httpx from "httpx"
import * as api from "brandguard/api"
import { CancellablePromise } from "real-cancellable-promise"

export const cache = new caching.Cache({
	namespace: "novacloud.documents.pages.urls",
	ttl: timex.duration.iso("PT48H").toMillis(),
})

export function cachable(pageId: string, ...options: httpx.option[]): CancellablePromise<string> {
	const retry = httpx.autoretry()
	return retry.wrap(() => api.documents.pages.url(pageId, ...options)).then((r) => r.url)
}

// get or load a document page url by page id.
export function current(aid: string, pageId: string, ...options: httpx.option[]): CancellablePromise<string> {
	return cache.maybe(`${aid}.${pageId}`, () => cachable(pageId, ...options))
}

export default cache
